"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MemoriesTab = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _badge = require("@design/ui/badge");
var _button = require("@design/ui/button");
var _spinner = require("@design/ui/spinner");
var _confirmationDialog = require("../confirmation-dialog/confirmation-dialog");
var _EditMemoryDialog = _interopRequireDefault(require("../EditMemoryDialog"));
var _savedItemsToolbar = require("./saved-items-toolbar");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t4 in e) "default" !== _t4 && {}.hasOwnProperty.call(e, _t4) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t4)) && (i.get || i.set) ? o(f, _t4, i) : f[_t4] = e[_t4]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var MemoriesTab = exports.MemoriesTab = function MemoriesTab(_ref) {
  var apis = _ref.apis,
    onRun = _ref.onRun,
    onError = _ref.onError;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = (0, _react.useState)(""),
    _useState6 = _slicedToArray(_useState5, 2),
    search = _useState6[0],
    setSearch = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedCategories = _useState8[0],
    setSelectedCategories = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    itemToEdit = _useState0[0],
    setItemToEdit = _useState0[1];
  var _useState1 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState1, 2),
    itemToDelete = _useState10[0],
    setItemToDelete = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    deletingId = _useState12[0],
    setDeletingId = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isRunning = _useState14[0],
    setIsRunning = _useState14[1];
  var loadMemories = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var lists, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          setError(null);
          _context2.p = 1;
          _context2.n = 2;
          return Promise.all(apis.map(/*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(api) {
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    _context.n = 1;
                    return api.list();
                  case 1:
                    return _context.a(2, _context.v.map(function (memory) {
                      return {
                        memory: memory,
                        api: api
                      };
                    }));
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref3.apply(this, arguments);
            };
          }()));
        case 2:
          lists = _context2.v;
          setItems(lists.flat().sort(function (a, b) {
            var _b$memory$createdAt, _a$memory$createdAt;
            return new Date((_b$memory$createdAt = b.memory.createdAt) !== null && _b$memory$createdAt !== void 0 ? _b$memory$createdAt : 0).getTime() - new Date((_a$memory$createdAt = a.memory.createdAt) !== null && _a$memory$createdAt !== void 0 ? _a$memory$createdAt : 0).getTime();
          }));
          _context2.n = 4;
          break;
        case 3:
          _context2.p = 3;
          _t = _context2.v;
          onError === null || onError === void 0 || onError(_t, "load_memories");
          setError("Failed to load memories");
          setItems([]);
        case 4:
          return _context2.a(2);
      }
    }, _callee2, null, [[1, 3]]);
  })), [apis, onError]);
  (0, _react.useEffect)(function () {
    loadMemories();
  }, [loadMemories]);
  var handleRun = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            setIsRunning(true);
            _context3.p = 1;
            _context3.n = 2;
            return onRun();
          case 2:
            _context3.n = 3;
            return loadMemories();
          case 3:
            _context3.n = 5;
            break;
          case 4:
            _context3.p = 4;
            _t2 = _context3.v;
            onError === null || onError === void 0 || onError(_t2, "run_learnings");
            setError("Failed to run learnings");
          case 5:
            _context3.p = 5;
            setIsRunning(false);
            return _context3.f(5);
          case 6:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 4, 5, 6]]);
    }));
    return function handleRun() {
      return _ref4.apply(this, arguments);
    };
  }();
  var toggleCategory = function toggleCategory(category) {
    setSelectedCategories(function (prev) {
      return prev.includes(category) ? prev.filter(function (c) {
        return c !== category;
      }) : [].concat(_toConsumableArray(prev), [category]);
    });
  };
  var handleConfirmDelete = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var memory, api, _t3;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            if (itemToDelete) {
              _context4.n = 1;
              break;
            }
            return _context4.a(2);
          case 1:
            memory = itemToDelete.memory, api = itemToDelete.api;
            setItemToDelete(null);
            setDeletingId(memory.id);
            _context4.p = 2;
            _context4.n = 3;
            return api.remove(memory.id);
          case 3:
            _context4.n = 4;
            return loadMemories();
          case 4:
            _context4.n = 6;
            break;
          case 5:
            _context4.p = 5;
            _t3 = _context4.v;
            onError === null || onError === void 0 || onError(_t3, "delete_memory");
            setError("Failed to delete memory");
          case 6:
            _context4.p = 6;
            setDeletingId(null);
            return _context4.f(6);
          case 7:
            return _context4.a(2);
        }
      }, _callee4, null, [[2, 5, 6, 7]]);
    }));
    return function handleConfirmDelete() {
      return _ref5.apply(this, arguments);
    };
  }();
  var tagCategories = (0, _react.useMemo)(function () {
    var set = new Set();
    var _iterator = _createForOfIteratorHelper(items !== null && items !== void 0 ? items : []),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var memory = _step.value.memory;
        var _iterator2 = _createForOfIteratorHelper(memory.tags),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var tag = _step2.value.tag;
            set.add(tag.name);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return Array.from(set).sort();
  }, [items]);
  var filtered = (0, _react.useMemo)(function () {
    var byCategory = selectedCategories.length === 0 ? items !== null && items !== void 0 ? items : [] : (items !== null && items !== void 0 ? items : []).filter(function (_ref6) {
      var memory = _ref6.memory;
      return memory.tags.some(function (_ref7) {
        var tag = _ref7.tag;
        return selectedCategories.includes(tag.name);
      });
    });
    var lowerSearch = search.trim().toLowerCase();
    if (!lowerSearch) return byCategory;
    return byCategory.filter(function (_ref8) {
      var _memory$contentText, _memory$contextText;
      var memory = _ref8.memory;
      return [(_memory$contentText = memory.contentText) !== null && _memory$contentText !== void 0 ? _memory$contentText : "", (_memory$contextText = memory.contextText) !== null && _memory$contextText !== void 0 ? _memory$contextText : ""].concat(_toConsumableArray(memory.tags.map(function (t) {
        return t.tag.name;
      }))).join(" ").toLowerCase().includes(lowerSearch);
    });
  }, [items, search, selectedCategories]);
  function renderMemory(item) {
    var memory = item.memory;
    var hasFooterRow = memory.tags.length > 0 || !!memory.createdAt;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "group flex flex-col items-start px-1 py-2 gap-1 border-b-2 border-transparent hover:bg-background-secondary-hover hover:border-border-hover transition-colors ".concat(deletingId === memory.id ? "opacity-50" : ""),
      "data-sentry-component": "renderMemory",
      "data-sentry-source-file": "MemoriesTab.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-row items-start gap-2 w-full",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex flex-col items-start gap-1 flex-1 min-w-0",
          children: [memory.contentText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "text-base text-foreground-primary",
            children: memory.contentText
          }), memory.contextText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "text-body-sm italic text-foreground-muted",
            children: memory.contextText
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex flex-row justify-end items-center gap-1 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            variant: "ghost",
            size: "icon-xs",
            "aria-label": "Edit memory",
            title: "Edit memory",
            onClick: function onClick() {
              return setItemToEdit(item);
            },
            "data-sentry-element": "Button",
            "data-sentry-source-file": "MemoriesTab.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.EditIcon, {
              "data-sentry-element": "EditIcon",
              "data-sentry-source-file": "MemoriesTab.tsx"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            variant: "ghost-destructive",
            size: "icon-xs",
            "aria-label": "Delete memory",
            title: "Delete memory",
            onClick: function onClick() {
              return setItemToDelete(item);
            },
            "data-sentry-element": "Button",
            "data-sentry-source-file": "MemoriesTab.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DeleteIcon, {
              "data-sentry-element": "DeleteIcon",
              "data-sentry-source-file": "MemoriesTab.tsx"
            })
          })]
        })]
      }), hasFooterRow && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-row items-center gap-1 w-full",
        children: [memory.tags.map(function (_ref9) {
          var tag = _ref9.tag;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_badge.Badge, {
            variant: "secondary",
            children: tag.name
          }, tag.id);
        }), memory.createdAt && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "ml-auto text-caption text-foreground-muted",
          children: new Date(memory.createdAt).toLocaleDateString()
        })]
      })]
    }, memory.id);
  }
  function renderBody() {
    if (items === null) return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "px-1 py-2 text-body text-foreground-muted",
      children: "Loading\u2026"
    });
    if (error) return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "px-1 py-2 text-body text-destructive-text",
      children: error
    });
    if (filtered.length === 0) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "py-8 text-center text-body-sm text-foreground-muted",
        children: "No memories found"
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-col gap-px",
      "data-sentry-component": "renderBody",
      "data-sentry-source-file": "MemoriesTab.tsx",
      children: [filtered.map(renderMemory), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "py-2 text-center text-body-sm text-foreground-muted",
        children: "End of list"
      })]
    });
  }
  var deleteDialog = itemToDelete ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
    tone: "destructive",
    title: "Delete memory",
    message: "Delete this memory? This action cannot be undone.",
    confirmLabel: "Delete",
    onConfirm: handleConfirmDelete,
    onCancel: function onCancel() {
      return setItemToDelete(null);
    }
  }) : null;
  var editDialog = itemToEdit ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditMemoryDialog.default, {
    memory: itemToEdit.memory,
    api: itemToEdit.api,
    onClose: function onClose() {
      return setItemToEdit(null);
    },
    onSaved: loadMemories
  }) : null;
  var runButton = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "px-3 pt-2",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
      type: "button",
      size: "sm",
      onClick: handleRun,
      disabled: isRunning,
      children: [isRunning ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {
        "data-icon": "inline-start",
        "aria-hidden": "true"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.SparklesIcon, {
        "data-icon": "inline-start"
      }), isRunning ? "Running…" : "Run learnings"]
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col h-full",
    "data-sentry-component": "MemoriesTab",
    "data-sentry-source-file": "MemoriesTab.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_savedItemsToolbar.SavedItemsToolbar, {
      searchQuery: search,
      onSearchChange: setSearch,
      searchPlaceholder: "Search memories\u2026",
      categories: tagCategories,
      selectedCategories: selectedCategories,
      onToggleCategory: toggleCategory,
      "data-sentry-element": "SavedItemsToolbar",
      "data-sentry-source-file": "MemoriesTab.tsx"
    }), runButton, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex-1 overflow-y-auto px-3 py-2",
      children: renderBody()
    }), deleteDialog, editDialog]
  });
};
var _default = exports.default = MemoriesTab;